<template lang="pug">
.col-md-4.col-lg-3.mb-5.text-center
  .coache-item
    img.coache-img(
      :src="[coach.photo ? coach.photo.image : imgs.basketballImg]"
    )
    .coache-info
      h5.title {{ coach.name }}
      .subtitle.mb-2 {{ coach.title }}
    hr
    .btn_wrapper(@click="toDetail(coach.id)")
      .detail_btn 學經歷介紹
      img.arrow(src="@/assets/img/icons/arrow_bottom.svg")
</template>

<script>
import basketballImg from "@/assets/img/icons/basketball-ball-solid.svg";

export default {
  name: "CoachItem",
  props: {
    coach: Object,
  },
  data() {
    return {
      imgs: {
        basketballImg,
      },
    };
  },
  methods: {
    toDetail(coachId) {
      this.$router.push({ name: "CoachesDetail", query: { id: coachId } });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/coaches/coach_item";
</style>
